import { render } from "./UserAppChrome.vue?vue&type=template&id=4913a027&scoped=true"
import script from "./UserAppChrome.vue?vue&type=script&lang=js"
export * from "./UserAppChrome.vue?vue&type=script&lang=js"

import "./UserAppChrome.vue?vue&type=style&index=0&id=4913a027&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4913a027"]])

export default __exports__